<template name="visitorCard">
  <div>
    <div class="content" style="display: none;">
      <div>
        <div class="qrCodeName">
          <img class="qrcode"  id ="CodeQr" src=""  width="400" height="400"/>
          <qrcode style="display: block;" :value="this.visitorData.qRcode" :options="{ width: 247, margin: 0.5 }"></qrcode>
          <div class="idCard">A 123456789012</div>
        </div>
      </div>
    </div>
    <div class="pic">
      <canvas id="myCanvas" style="display: none;">
        您的浏览器不支持canvas
      </canvas>
    </div>
    <img id="imgbox" src="/resource/dist/img/1.jpg" alt="" style="width: 100%;height:1010px;">
  </div>
</template>

<script type="text/javascript">
  import { getSecurityCardInfo, getNormalCardInfo, postCardImageUrl } from '@/utils/api';
  import { checkNested } from '@/utils/utils';
  import $ from 'jquery';
  import Vue from 'vue';
  import VueQrcode from '@chenfengyuan/vue-qrcode';
  Vue.component(VueQrcode.name, VueQrcode);
  export default {
    name: "visitorCard",

    data() {
      return {
        carId: '',
        qrcode: '',
        visitorData: {},
        isNormal: -1,
      }
    },
    created() {
      this.carId = this.$route.params.id;
      this.qrcode = this.$route.params.qrcode;
      this.isNormal = this.$route.params.isNormal;
      if (this.isNormal == 0 ) {
        this.getnotNormalData(this.carId, this.qrcode);
      } else if (this.isNormal == 1) {
        this.getNormalData(this.carId, this.qrcode);
      }
    },
    watch: {
      $route() {
        this.carId = this.$route.params.id;
        this.qrcode = this.$route.params.qrcode;
      }
    },
    mounted() {
    },
    methods: {
      getnotNormalData(carId, qrcode) {
        const that = this;
        getSecurityCardInfo(carId, qrcode).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.model) {
              this.visitorData = res.data.content.model;
              console.log(this.visitorData)
              if (this.visitorData) {
               const myCanvas = document.getElementsByTagName("canvas")[0];
               const self = this;
               setTimeout(function function_name(argument) {
                  const imgQrcode = self.convertCanvasToImage(myCanvas)
                  // console.log(imgQrcode);
                  $("#CodeQr").attr("src", imgQrcode);
                  const CodeQr = $('#CodeQr')[0].src;
                  const imagePath = self.visitorData.imagePath;
                  const avatar = self.visitorData.avatar;
                  const visitorName = self.visitorData.visitorName;
                  const areaName = self.visitorData.cardStyleName;
                  const validDate = "有效日期: "+self.visitorData.effectiveTime;
                  const company = "公司名称: "+self.visitorData.companyName;
                  const idCard = self.visitorData.cardNumber;
                  const checkCode = self.visitorData.qRcode;
                  const newCheck = checkCode.split(',');
                  const styleType = self.visitorData.styleType;
                  if (imagePath && CodeQr  && visitorName && areaName && validDate && company && idCard && newCheck) {
                   if (styleType == 1) {
                     self.drawImage(imagePath, CodeQr, avatar, visitorName, areaName, validDate, company, idCard, newCheck);
                   }
                   else if (styleType == 2) {
                     self.drawImageTwo(imagePath, CodeQr, avatar, visitorName, areaName, validDate, company, idCard, newCheck);
                   }
                  }
               },10);
              }
            }
          }
        })
      },
      getNormalData(carId, qrcode) {
        getNormalCardInfo(this.carId, this.qrcode).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            //console.log(res.data.content.model);
            if (res.data.content.model) {
              this.visitorData = res.data.content.model;
              if (this.visitorData) {
               const myCanvas = document.getElementsByTagName("canvas")[0];
               const self = this;
               setTimeout(function function_name() {
                 const imgQrcode = self.convertCanvasToImage(myCanvas);
                 $("#CodeQr").attr("src", imgQrcode);
                 const CodeQr = $('#CodeQr')[0].src;
                 const imagePath = self.visitorData.imagePath;
                 const areaName = "访客卡：" +self.visitorData.cardStyleName;
                 const idCard = self.visitorData.cardNumber;
                 const checkCode = self.visitorData.qRcode;
                 const newCheck = checkCode.split(',');
                 const styleType = self.visitorData.styleType;
                 if (imagePath && CodeQr  && areaName  && idCard && newCheck) {
                   if (styleType == 3) {
                     self.drawNormalImage(imagePath, CodeQr, areaName, idCard, newCheck);
                   } else if (styleType == 4) {
                     self.drawNormalImageTwo(imagePath, imgQrcode, areaName, idCard, newCheck);
                   }
                 }
               },10); 
              }
            }
          }
        })
      },
      drawImage(imagePath, imgQrcode, avatarImgs, visitorName, areaName, validDate, company, idCard, checkCode) {
        var downloadImg = '';
        const canvas = document.getElementById("myCanvas");
        const imgbox = document.getElementById("imgbox");
        const context = canvas.getContext("2d");
        canvas.width = 639;
        canvas.height = 1010;
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height; 
        const img = new Image();
        const imgCode = new Image();
        const avatarImg = new Image();
        img.crossOrigin = '';
        avatarImg.crossOrigin = '';
        const that = this;
        that.asyncFunction(imagePath,avatarImgs,context,canvasWidth,canvasHeight,imagePath, imgQrcode, avatarImgs, visitorName, areaName, validDate, company, idCard, checkCode);
         
      },
      async  asyncFunction(src1,src2,context,canvasWidth,canvasHeight,imagePath, imgQrcode, avatarImgs, visitorName, areaName, validDate, company, idCard, checkCode) {
         await this.loadImgSync(src1).then(data => {
          context.drawImage(data, 0, 0, 639, 1010);
        })
        const that = this;
        await this.loadImgSync2(src2).then(data => {
          var downloadImg = '';
          const canvas = document.getElementById("myCanvas");
          const imgbox = document.getElementById("imgbox");
          const context = canvas.getContext("2d");
          //context.drawImage(data, 0, 0, 639, 1010);
          that.rectImg(context, data, canvasWidth / 3.6, canvasHeight / 9.3, 95);
          const imgCode = new Image();
          //console.log(imgQrcode)
          imgCode.src = imgQrcode;
          context.drawImage(imgCode, canvasWidth / 2.7, canvasHeight / 1.3, canvasWidth / 4, canvasHeight / 6);
          
          context.fillStyle = "#000";
          context.textAlign = "center";
          context.font = "34px 方正正中黑简体";
          context.fillText(visitorName, canvasWidth / 2, canvasHeight / 1.9);

          context.fillStyle = "#000";
          context.textAlign = "center";
          context.font = "50px 方正正中黑简体";
          context.fillText(areaName, canvasWidth / 2, canvasHeight / 1.7);

          context.font = "30px 方正正中黑简体";
          context.textAlign = "left";
          context.fillText(validDate, canvasWidth / 10.8, canvasHeight / 1.55);

          context.font = "30px 方正正中黑简体";
          context.textAlign = "left";
          //context.fillText(company, canvasWidth / 20, canvasHeight / 1.56);
          const companylist = that.textSubstr(context,company,canvasWidth,canvasHeight);

          context.fillText(companylist.text, canvasWidth / 10.8, canvasHeight / 1.45);
          context.fillText(companylist.content, canvasWidth / 3.3, canvasHeight / 1.36);


          context.font = "28px 方正正中黑简体";
          context.textAlign = "center";
          context.fillText(idCard, canvasWidth / 2, canvasHeight / 1.025);


          downloadImg = canvas.toDataURL("image/jpg", 0.7);
          //console.log("downloadImg===="+downloadImg);

          imgbox.src = downloadImg;
          //console.log(checkCode)
          if (downloadImg !='') {
            const isNormal = checkCode[0] === "1" ? 'true': 'false';
            const postData = {
              "cardId": checkCode[1],
              "imageBase64": downloadImg,
              "isNormal": isNormal,
              "checkcode": checkCode[2]
            }

            if (postData) {
              that.sendCardImg(postData);
            }
          }

        })
      },
      loadImgSync(src) {
        return new Promise(resolve => {
          let img = new Image();
          img.setAttribute('crossOrigin', 'Anonymous');
          img.onload = () => {
            resolve(img);
          }
          img.src = src;
        })
      },
      loadImgSync2(src) {
        return new Promise(resolve => {
          let avatarImg = new Image();
          avatarImg.setAttribute('crossOrigin', 'Anonymous');
          avatarImg.onload = () => {
            resolve(avatarImg);
          }
          avatarImg.src = src;
        })
      },
      textSubstr(context,company,canvasWidth,canvasHeight) {
        let lineWidth = 0;
        let oneText = [];
        let twoText = [];
        const newTxt = company.split('');
        //console.log(newTxt);
        for (let i=0;i<newTxt.length;i++) {
          if ((canvasWidth - 90) > lineWidth) {
            lineWidth += context.measureText(newTxt[i]).width;
            oneText.push(company[i]);
          } else {
            twoText.push(company[i]);
          }
        }
        const text = oneText.join('');
        const content = twoText.join('');
        const newObj = {
          'text': text,
          'content': content
        }
        return newObj;
      },
      drawImageTwo(imagePath, imgQrcode, avatarImgs, visitorName, areaName, validDate, company, idCard, checkCode) {
        var downloadImg;
        const canvas = document.getElementById("myCanvas");
        const imgbox = document.getElementById("imgbox");
        const context = canvas.getContext("2d");
        canvas.width = 639;
        canvas.height = 1010;
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height; 
        const img = new Image();
        const imgCode = new Image();
        //const avatarImg = new Image();
        img.crossOrigin = '';
        img.src = imagePath;
        //avatarImg.crossOrigin = '';
        // avatarImg.src = avatarImgs;
        imgCode.src = imgQrcode;
        const that = this;
        img.onload = function () {
          //console.log(img)
          context.drawImage(img, 0, 0, 639, 1010);//按设计稿图片比例渲染图片高度         
          context.drawImage(imgCode, canvasWidth / 3.2, canvasHeight / 1.5, canvasWidth / 2.6, canvasHeight / 4.5);

          context.fillStyle = "#000";
          context.textAlign = "center";
          context.font = "36px 方正正中黑简体";
          context.fillText(visitorName, canvasWidth / 2, canvasHeight / 2.5);

          context.fillStyle = "#000";
          context.textAlign = "center";
          context.font = "50px 方正正中黑简体";
          context.fillText(areaName, canvasWidth / 2, canvasHeight / 2.15);

          context.font = "30px 方正正中黑简体";
          context.textAlign = "left";
          context.fillText(validDate, canvasWidth / 10.8, canvasHeight / 1.85);

          context.font = "30px 方正正中黑简体";
          context.textAlign = "left";
          //context.fillText(company, canvasWidth / 20, canvasHeight / 1.56);
          const companylist = that.textSubstr(context,company,canvasWidth,canvasHeight);

          context.fillText(companylist.text, canvasWidth / 10.8, canvasHeight / 1.7);
          context.fillText(companylist.content, canvasWidth / 3.3, canvasHeight / 1.58);

          context.font = "28px 方正正中黑简体";
          context.textAlign = "center";
          context.fillText(idCard, canvasWidth / 2, canvasHeight / 1.08);

          downloadImg = canvas.toDataURL("image/jpg", 0.7);
          //console.log("downloadImg===="+downloadImg);
          imgbox.src = downloadImg;
          //console.log(checkCode)
          const isNormal = checkCode[0] === "1" ? 'true': 'false';
          const postData = {
            "cardId": checkCode[1],
            "imageBase64": downloadImg,
            "isNormal": isNormal,
            "checkcode": checkCode[2]
          }
          if (postData) {
            that.sendCardImg(postData);
          } 
        } 
      },
      drawNormalImage(imagePath, imgQrcode, areaName, idCard, checkCode) {
        var downloadImg;
        const canvas = document.getElementById("myCanvas");
        const imgbox = document.getElementById("imgbox");
        const context = canvas.getContext("2d");
        canvas.width = 639;
        canvas.height = 1010;
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height; 
        const img = new Image();
        const imgCode = new Image();
        img.crossOrigin = '';
        img.src = imagePath;
        imgCode.src = imgQrcode;
        const that = this;
        img.onload = function () {
          //console.log(img)
          context.drawImage(img, 0, 0, 639, 1010);//按设计稿图片比例渲染图片高度         
          context.drawImage(imgCode, canvasWidth / 3.2, canvasHeight / 1.7, canvasWidth / 2.6, canvasHeight / 4);

          context.fillStyle = "#000";
          context.textAlign = "center";
          context.font = "42px 方正正中黑简体";
          context.fillText(areaName, canvasWidth / 2, canvasHeight / 7);

          context.fillStyle = "#fff";
          context.font = "30px 方正正中黑简体";
          context.textAlign = "center";
          context.fillText(idCard, canvasWidth / 2, canvasHeight / 1.13);

          downloadImg = canvas.toDataURL("image/jpg", 0.7);
          //console.log("downloadImg===="+downloadImg);
          imgbox.src = downloadImg;
          //console.log(checkCode)
          const isNormal = checkCode[0] === "1" ? 'true': 'false';
          const postData = {
            "cardId": checkCode[1],
            "imageBase64": downloadImg,
            "isNormal": isNormal,
            "checkcode": checkCode[2]
          }
          //console.log(postData)
          if (postData) {
            that.sendCardImg(postData);
          } 
        } 
      },
      drawNormalImageTwo(imagePath, imgQrcode, areaName, idCard, checkCode) {
        var downloadImg;
        const canvas = document.getElementById("myCanvas");
        const imgbox = document.getElementById("imgbox");
        const context = canvas.getContext("2d");
        canvas.width = 639;
        canvas.height = 1010;
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height; 
        const img = new Image();
        const imgCode = new Image();
        img.crossOrigin = '';
        img.src = imagePath;
        imgCode.src = imgQrcode;
        const that = this;
        img.onload = function () {
          context.drawImage(img, 0, 0, 639, 1010);//按设计稿图片比例渲染图片高度         
          context.drawImage(imgCode, canvasWidth / 3.9, canvasHeight / 3, canvasWidth / 2, canvasHeight / 3);
          context.fillStyle = "#000";
          context.textAlign = "center";
          context.font = "38px 方正正中黑简体";
          context.fillText(areaName, canvasWidth / 2, canvasHeight / 1.4);

          context.fillStyle = "#fff";
          context.font = "34px 方正正中黑简体";
          context.textAlign = "center";
          context.fillText(idCard, canvasWidth / 2, canvasHeight / 3.5);

          downloadImg = canvas.toDataURL("image/jpg", 0.7);
          //console.log("downloadImg===="+downloadImg);
          imgbox.src = downloadImg;
          //console.log(checkCode)
          const isNormal = checkCode[0] === "1" ? 'true': 'false';
          const postData = {
            "cardId": checkCode[1],
            "imageBase64": downloadImg,
            "isNormal": isNormal,
            "checkcode": checkCode[2]
          }
          //console.log(postData)
          if (postData) {
            that.sendCardImg(postData);
          } 
        } 
      },
      convertCanvasToImage(canvas) {
        //canvas.toDataURL返回的是一串Base64编码的URL,当然,浏览器自己肯定支持
        //指定格式PNG
        if (this.visitorData.qRcode != '') {
          var dataURl = canvas.toDataURL("image/jpg", 0.7);
        }
        return dataURl;
      },
      rectImg(ctx, img, x, y) {
        const rectWidth = ctx.canvas.width / 2.2;
        const rectHeight = ctx.canvas.height / 2.68;
        ctx.save();
        ctx.rect(x, y, rectWidth, rectHeight);
        ctx.clip();

        const imgRatio = img.width / img.height;
        const rectRation = rectWidth / rectHeight;
        if (imgRatio >= rectRation) {
          const leftX =  (img.width - img.height * rectRation) / 2;
          ctx.drawImage(img, leftX, 0, (img.width - leftX), img.height, // source rectangle
                   x, y, rectWidth, rectHeight); // destination 
        } else {
          const topY = (img.height - img.width / rectRation) / 2;
          ctx.drawImage(img, 0, topY, img.width, img.height - topY, // source rectangle
                    x, y, rectWidth, rectHeight); // destination 
        }
        ctx.restore();
      },
      sendCardImg(data) {
        postCardImageUrl(data).then((res) => {
           if (checkNested(res, 'data', 'content', 'model')) {
            //alert(res.data.content.message);
           }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    width:639px;
    height: 1010px;
    margin: 0 auto;
    text-align: center;
    .avatar {
      position: relative;
      padding-top: 165px;
      img {
        width: 191px;
        height: 191px;
        border-radius: 50%;
      }
      .visitorName {
        font-size: 34px;
        font-weight: 500;
        color: #fff;
        line-height: 28px;
        padding-top: 30px;
      }
    }
    .areaName {
      font-size: 50px;
      font-weight: 500;
      color: #000;
      padding-top: 54px;
    }
    .validDate,
    .company {
      line-height: 38px;
      width: 75%;
      text-align: left;
      margin: 0 auto;
      font-size: 30px;
      color: #000;
    }
  }
</style>